import { render, staticRenderFns } from "./burgermenu.vue?vue&type=template&id=083e6d9f&scoped=true&"
import script from "./burgermenu.vue?vue&type=script&lang=js&"
export * from "./burgermenu.vue?vue&type=script&lang=js&"
import style0 from "./burgermenu.vue?vue&type=style&index=0&id=083e6d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e6d9f",
  null
  
)

export default component.exports